<div class="container pt-2 pb-2 chatbot" style="display: none">
  <div class="row">
    <div class="col-sm-12">
      <h3 class="text-center">
        <span class="highlight">Introducing the new CAL Chatbot </span>
        <button class="btn-link text-uppercase float-end close" (click)="close()">&times;</button>
      </h3>
      <img src="../../assets/images/chatbot-img.jpg" align="left" />
      <p class="mt-4">
        The CAL ChatBot is available at the bottom right corner of your screen to help you with your inquiries about any of our products,
        and also leave us any feedback which would be much appreciated, thank you!<br />
        <button class="btn-cancel m-t text-center btn-sm btn-shadow me-2 float-end" (click)="close()" type="button">Close</button>
      </p>
    </div>
  </div>
</div>
<div class="container pt-2 pb-2">
  <div class="row">
    <div class="col-sm-12">
      <h3 class="text-center">
        <span class="highlight">Important Notice</span>
        <button class="btn-link text-uppercase float-end close" (click)="close()">&times;</button>
      </h3>
      <div class="mobile-scroll">
        Dear valued customer,<br />
        <p>
          Please note that <span class="highlight">Deutsche Bank</span> is experiencing delays in receiving CEFT (Common electronic fund
          transfers). Therefore, as previously instructed kindly perform;
        </p>
        <p><b>SLIP</b> transfer for investment value below LKR 5 million</p>
        <p><b>RTGS</b> transfer for investment value above LKR 5 million</p>
        <p>In order to accommodate CEFT, you may transfer to a CALI Unit Trust Temporary Bank account as provided below:-</p>

        <table cellpadding="10" class="d-md-block">
          <thead>
            <tr>
              <th>1st Preference</th>
              <th>OR 2nd Preference</th>
            </tr>
          </thead>
          <tr>
            <td valign="top" style="border-right: 1px solid #dcdbdb">
              <b>Commercial Bank PLC Branch - Nawam Mawatha</b> <br />
              A/C number- 1030026049 <br />
              A/C name - Capital Alliance Investments Limited
            </td>
            <td valign="top">
              <b>Nations Trust Bank PLC Branch - Nawam Mawatha</b><br />
              A/C number - 024212025941 <br />
              A/C name - Capital Alliance Investments Limited
            </td>
          </tr>
        </table>
        <table cellpadding="10" class="dsm-block">
          <thead>
            <tr>
              <th>1st Preference</th>
            </tr>
          </thead>
          <tr>
            <td valign="top">
              <b>Commercial Bank PLC Branch - Nawam Mawatha</b> <br />
              A/C number- 1030026049 <br />
              A/C name - Capital Alliance Investments Limited
            </td>
          </tr>
        </table>
        <table cellpadding="10" class="dsm-block">
          <thead>
            <tr>
              <th>OR 2nd Preference</th>
            </tr>
          </thead>
          <tr>
            <td valign="top">
              <b>Nations Trust Bank PLC Branch - Nawam Mawatha</b><br />
              A/C number - 024212025941 <br />
              A/C name - Capital Alliance Investments Limited
            </td>
          </tr>
        </table>
        <p>
          Fund transfers to the CALI Unit Trust Temporary Bank accounts (Commercial Bank / Nations Trust Bank), must be credited in the
          account <b>by 9.00am</b> for same day unit creation. Failing which, units will be created on the following day (T+1).
        </p>
        <div class="row no-gutters button-row w-100">
          <div class="col-sm-12 text-center">
            <button class="m-t text-center btn-shadow" (click)="close()" type="button">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
